// @flow
/**
 * https://engineering.paypalcorp.com/confluence/display/MUSIC/P2P+%7C+App+Store+Downloads
 */
import { trackLinkWithData, trackImpression } from 'lib/analytics/fpti'
import { tracking } from '../../lib/analytics/mParticle'
import Events from '../../lib/analytics/eventTags'

export const PAGE_ACTIONS = {
  DOWNLOAD: 'download',
  CLOSE: 'close',
}

// This experiment is only enabled for send money flow at the moment.
const PAGE_GROUP = 'main:p2p:unified:send:done:appdownload'
const PAGE_NAME = 'main:p2p:unified:send:done:appdownload'

export function trackAppPushImpression() {
  trackImpression(PAGE_GROUP, PAGE_NAME)
  tracking(Events.p2p_app_store_screen_shown({}))
}

/**
 * Track users clicks via FPTI analytics
 * @param {string} pageAction - FPTI data to track on clicks
 */
export function trackAppPushClick(pageAction: string) {
  switch (pageAction) {
    case PAGE_ACTIONS.DOWNLOAD:
      trackLinkWithData('app_download', PAGE_GROUP, PAGE_NAME, {}, 'link')
      tracking(Events.p2p_app_store_download_pressed({}))
      break
    case PAGE_ACTIONS.CLOSE:
      trackLinkWithData('close', PAGE_GROUP, PAGE_NAME, {}, 'link')
      tracking(Events.p2p_app_store_close_pressed({}))
      break
    default:
      break
  }
}
